module.exports = {
  calculateCart: require('./calculate.js'),
  restoreCalc: require('./restore.js')
};